import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { passwdPc, setPcMainInfo } from '@store/actions/userAction';
import InstallPopup from '@components/common/InstallPopup';

const LoginMain = () => {
  const {
    userInfo: { getIdBysearch },
  } = useSelector(state => state.userReducer);

  const dispatch = useDispatch();
  const history = useHistory();
  const isExternal = $utils.checkExternal();

  const [loginInfo, setLoginInfo] = useState({
    userId: '',
    pw: '',
  });
  const [isFocused, setIsFocused] = useState([
    { name: 'userId', focused: false },
    { name: 'pw', focused: false },
  ]);
  const [error, setError] = useState(false);
  const [showInstallPop, setShowInstallPop] = useState(false);

  useEffect(() => {
    dispatch(
      setPcMainInfo({
        isUseFirst: false,
        isSearchId: false,
        isSearchPw: false,
        isSearchIdByCerti: false,
      }),
    );
  }, []);

  useEffect(() => {
    if (getIdBysearch.trim() !== '') {
      setLoginInfo({
        ...loginInfo,
        ['userId']: getIdBysearch,
      });
    }
  }, [getIdBysearch]);

  useEffect(() => {
    if (isExternal && localStorage.getItem('save_main_userId')) {
      const { checked, userId } = JSON.parse(
        localStorage.getItem('save_main_userId'),
      );

      if (checked) {
        setLoginInfo({ ...loginInfo, ['userId']: userId || '' });
      }
    }
  }, []);

  const onInputChangeHandler = e => {
    const { name, value } = e.target;

    setLoginInfo({
      ...loginInfo,
      [name]: value,
    });
  };
  const onInputFocusHandler = e => {
    const { name } = e.target;

    setIsFocused(
      isFocused.map(item => {
        return name === item.name ? { ...item, focused: true } : item;
      }),
    );
  };
  const onInputBlurHandler = e => {
    const { name } = e.target;

    setIsFocused(
      isFocused.map(item => {
        return name === item.name ? { ...item, focused: false } : item;
      }),
    );
  };
  const onInputKeyDownHandler = e => {
    const keyCode = e.keyCode;

    if (keyCode === 13) {
      onButtonClickHandler();
    }
  };

  const onButtonClickHandler = () => {
    const { userId, pw } = loginInfo;

    if (userId === '' || pw === '') {
      setError(true);
      return;
    }

    dispatch(
      passwdPc({
        id: userId.toUpperCase(),
        pw: pw,
      }),
    );
    setError(false);
  };

  const getFocusOrNot = inputName => {
    return isFocused.some(item => {
      return item.name === inputName && item.focused === true;
    });
  };

  const onUseFirst = () => {
    dispatch(
      setPcMainInfo({
        isUseFirst: true,
        isSearchId: false,
        isSearchPw: false,
        isSearchIdByCerti: false,
      }),
    );
    history.push('/login/first');
  };
  const onSearchId = () => {
    dispatch(
      setPcMainInfo({
        isUseFirst: false,
        isSearchId: true,
        isSearchPw: false,
        isSearchIdByCerti: false,
      }),
    );
    history.push('/login/first');
  };
  const onSearchPw = () => {
    dispatch(
      setPcMainInfo({
        isUseFirst: false,
        isSearchId: false,
        isSearchPw: true,
        isSearchIdByCerti: false,
      }),
    );
    history.push('/login/first');
  };

  const onSaveIdYn = e => {
    const { checked } = e.target;

    localStorage.setItem(
      'save_main_userId',
      JSON.stringify({
        checked,
      }),
    );
  };

  return (
    <>
      <div className={`${REQUEST_TYPE === 'external' ? 'tab-con active' : ''}`}>
        <div
          className={`tit-area ${REQUEST_TYPE === 'external' ? 'mgt-0' : ''}`}
        >
          <p className={`tit ${REQUEST_TYPE === 'external' ? 'mgb-0' : ''}`}>
            <span>
              반갑습니다.
              <br />
            </span>
            <strong>ID</strong>와 <strong>비밀번호</strong>를 입력해주세요.
          </p>
        </div>
        <div className="logincon-area">
          <div className="login-form">
            <div
              className={`input-wrap val ${
                getFocusOrNot('userId') === true ? 'focus' : ''
              }`}
            >
              <div className="input-area">
                <label htmlFor="name" className="input-tit">
                  ID
                </label>
                <input
                  type="text"
                  name="userId"
                  id="userId"
                  className="input"
                  autoComplete="off"
                  value={loginInfo.userId}
                  placeholder="통합사번 7자리를 입력하세요."
                  onChange={onInputChangeHandler}
                  onFocus={onInputFocusHandler}
                  onBlur={onInputBlurHandler}
                  onKeyDown={onInputKeyDownHandler}
                />
              </div>
            </div>
            {error && loginInfo.userId.length === 0 ? (
              <p className="text-info ico-type error">ID를 입력해주세요.</p>
            ) : (
              ''
            )}
            <div
              className={`input-wrap val ${
                getFocusOrNot('pw') === true ? 'focus' : ''
              }`}
            >
              <div className="input-area">
                <label htmlFor="name" className="input-tit">
                  비밀번호
                </label>
                <input
                  type="password"
                  name="pw"
                  id="pw"
                  className="input"
                  autoComplete="off"
                  value={loginInfo.pw}
                  placeholder="비밀번호를 입력하세요."
                  onChange={onInputChangeHandler}
                  onFocus={onInputFocusHandler}
                  onBlur={onInputBlurHandler}
                  onKeyDown={onInputKeyDownHandler}
                />
              </div>
            </div>
            {error && loginInfo.pw.length === 0 ? (
              <p className="text-info ico-type error">
                비밀번호를 입력해주세요.
              </p>
            ) : (
              ''
            )}
            <div className="btn-area">
              <button
                type="button"
                className="btn-l blue"
                onClick={onButtonClickHandler}
              >
                로그인
              </button>
            </div>
            <ul className="txt-underline-list">
              <li>
                <a style={{ cursor: 'pointer' }} onClick={onSearchId}>
                  ID(사번)을 잊으셨어요?
                </a>
                <div>
                  <a style={{ cursor: 'pointer' }} onClick={onSearchId}>
                    또는 (구.<span className="orange">푸르덴셜</span> 사번만
                    알고 있는 경우)
                  </a>
                </div>
              </li>
              <li>
                <a style={{ cursor: 'pointer' }} onClick={onSearchPw}>
                  비밀번호를 잊으셨어요?
                </a>
              </li>
              <li>
                <a style={{ cursor: 'pointer' }} onClick={onUseFirst}>
                  처음 사용 인 경우 비밀번호를 등록하세요.
                </a>
              </li>
            </ul>
            {isExternal ? (
              <div className="id-save">
                <div className="check-wrap chk-style">
                  <input
                    type="checkbox"
                    name="radioid"
                    id="radioid"
                    readOnly
                    onClick={onSaveIdYn}
                    defaultChecked={
                      (localStorage.getItem('save_main_userId') &&
                        JSON.parse(localStorage.getItem('save_main_userId'))
                          .checked) ||
                      false
                    }
                  />
                  <label htmlFor="radioid">아이디 저장</label>
                </div>
              </div>
            ) : (
              ''
            )}

            {$utils.isExternal && !$utils.isTablet && (
              <ul className="txt-underline-list">
                <li>
                  <a
                    style={{
                      cursor: 'pointer',
                      fontSize: '1.5rem',
                      color: '#e48512',
                    }}
                    onClick={() => setShowInstallPop(true)}
                  >
                    설치 프로그램
                  </a>
                </li>
              </ul>
            )}

            {showInstallPop && (
              <InstallPopup
                showInstallPop={showInstallPop}
                isShowCheckList={false}
                onShowPopup={() => setShowInstallPop(true)}
                onHidePopup={() => setShowInstallPop(false)}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginMain;
